import CheckboxGroup from '../components/CheckboxGroup';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const TransportationSelect = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>기타</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-12 col-sm-4 col-md-4">
            <CheckboxGroup
              checked={reportMxData?.by_church_car || 0} //
              label={'교회차량'}
              disabled={isReadOnly}
              setReportMxData={setReportMxData}
              reportColumnName={'by_church_car'}
            />
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <CheckboxGroup
              checked={reportMxData?.by_public_transport || 0} //
              label={'무차량 교통비 보조'}
              disabled={isReadOnly}
              setReportMxData={setReportMxData}
              reportColumnName={'by_public_transport'}
            />
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <CheckboxGroup
              checked={reportMxData?.by_own_car || 0} //
              label={'개인소유 차량 보조'}
              disabled={isReadOnly}
              setReportMxData={setReportMxData}
              reportColumnName={'by_own_car'}
            />
          </div>
          <div className="col-xs-8 col-sm-9 col-md-9" />
        </div>
      </div>
    </div>
  );
};

export default TransportationSelect;
